module.exports = __webpack_public_path__ + "img/warning.61921222.png";